import styled from 'styled-components';

import { BACKGROUND_SIDE_BAR, BORDER_SIDE_BAR, HEIGHT_HEADER, WIDTH_SIDE_BAR, WIDTH_SIDE_BAR_SEPARATOR_MOBILE } from '../../../globals';


export const StyledSideBar = styled.div`
  top: ${HEIGHT_HEADER - 1}px;  
  left: 0px;
  position: fixed;
  width: ${WIDTH_SIDE_BAR}px;
  height: 100%;   
  z-index: 400;
  
  background-color: ${BACKGROUND_SIDE_BAR}; 
  border-right: 2px solid ${BORDER_SIDE_BAR};

  padding: 0px;

  ul {
    list-style-type: none;
    padding: 0px;
    margin: 0px;
  }

  @media (max-width: 767px) {
    position: relative;
    top: -1px;
    width: 100%;
    border-right: none;


    ul {
      list-style: none;
      display: table;
      width: 100%;
      height: 50px;
    }

    li {
      text-align: center;
      display: table-cell;
      height: 100%;
      vertical-align:middle;
    }

    .sidebar-button {
      width: auto;
      
    }

    .sidebar-separator {
      width: ${WIDTH_SIDE_BAR_SEPARATOR_MOBILE}px;
    }


  }
`;
